import { render, staticRenderFns } from "./AppFooter.html?vue&type=template&id=60c63086&"
import script from "./AppFooter.js?vue&type=script&lang=js&"
export * from "./AppFooter.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports